// AttachmentChips.jsx — chips visuais pra arquivos pendentes no composer.
//
// Sprint v8.3 — Pedro pediu drag-and-drop de arquivos no chat.
// E2-WS1-T02 (tier-s-chat) — chips liquid-glass: thumbnail (imagem) OU ícone
// do tipo, nome, tamanho/extensão, X pra remover. A lógica de display
// (kind/thumbnail/labels) vive no helper PURO attachmentChip.js; aqui só
// renderiza. Acima do textarea, como uma linha de "anexos pendentes".

import { File, FileCode, FileImage, FileText, FileVideo, Music, X } from 'lucide-react';
import { attachmentChipData } from '../../lib/attachmentChip.js';
import './chat/redesign.css';

const ICON_BY_KIND = {
  image: FileImage,
  video: FileVideo,
  audio: Music,
  pdf: FileText,
  markdown: FileText,
  code: FileCode,
  text: FileText,
  binary: File,
};

export default function AttachmentChips({ files = [], onRemove }) {
  if (files.length === 0) return null;
  return (
    <ul aria-label="Anexos pendentes" className="rx-attachrow pt-1.5">
      {files.map((f) => {
        const chip = attachmentChipData(f);
        const Icon = ICON_BY_KIND[chip.kind] || File;
        return (
          <li key={chip.id}>
            <span
              className="rx-attachchip"
              title={`${chip.name} · ${chip.extLabel} · ${chip.sizeLabel}`}
            >
              {chip.isImage ? (
                <img
                  src={chip.thumbnailUrl}
                  alt=""
                  aria-hidden="true"
                  width={26}
                  height={26}
                  className="rx-attach-thumb"
                />
              ) : (
                <span className="rx-attach-ic" aria-hidden="true">
                  <Icon size={14} />
                </span>
              )}
              <span className="rx-attach-meta">
                <span className="rx-attach-name">{chip.name}</span>
                <span className="rx-attach-sub">
                  {chip.extLabel} · {chip.sizeLabel}
                </span>
              </span>
              <button
                type="button"
                onClick={() => onRemove?.(chip.id)}
                aria-label={chip.removeLabel}
                className="rx-attach-x"
              >
                <X size={11} aria-hidden="true" />
              </button>
            </span>
          </li>
        );
      })}
    </ul>
  );
}
